import { Andamento } from './andamento.model';
import { Arquivo } from './arquivo.model';
import { CategoriaSolicitacao } from './categoria-solicitacao.model';
import { Fat } from './fat.model';
import { FuncionarioBasico } from './funcionario-basico.model';
import { MovimentoAndamento } from './movimento-andamento.model';
import { Solicitante } from './solicitante.model';
import { SolicitacaoArmaFogo } from './solicitacao-arma-fogo.model';
import { TipoSolicitacao } from './tipo-solicitacao.model';
import { UnidadeBM } from './unidadebm.model';

export enum EnumSituacaoDocumentacao {
  REGULAR = 'REGULAR',
  PENDENTE = 'PENDENTE',
  DOCUMENTOS_ENVIADOS = 'DOCUMENTOS ENVIADOS',
}

export enum EnumSituacaoInteracao {
  SEM_INTERACAO = 'SEM INTERACAO',
  AGUARDANDO_RESPOSTA = 'AGUARDANDO RESPOSTA',
}

// Espelha o WS (AndamentoDAO::LIMITE_INTERACOES_ABERTAS); some quando o GResult adotar o GET /andamento/proximos por solicitação.
export const LIMITE_INTERACOES_ABERTAS = 2;

export interface Solicitacao {
  CODSOLICITACAO?: number;
  NUMERO?: string; // 00.00000.2024 (Tipo.CodSolicitação.Ano)
  IP?: string;
  CADASTRO?: string;
  ENVIO: string;
  SITUACAO: {
    CODSITUACAO: number;
    TITULO?: string;
  }; // 1 - Construindo, 2 - Em Andamento, 3 - Finalizada, 4 - Cancelada
  ATUALIZACAO?: string;
  PREVISAO?: string;
  ORIGEM: UnidadeBM; // Origem da Solicitação. Podendo ser uma Unidade BM ou apenas uma cidade (para usuários externos)
  CATEGORIASOLICITACAO: CategoriaSolicitacao;
  TIPOSOLICITACAO?: TipoSolicitacao;
  SOLICITANTE: Solicitante;
  UNIDADEATUAL?: UnidadeBM; // Unidade onde a solicitação se encontra atualmente
  UNIDADERESPONSAVEL?: UnidadeBM; // Unidade responsável pela solicitação
  UNIDADEDESTINOPRIMEIROENVIO?: UnidadeBM; // Unidade destinatária do primeiro envio válido da solicitação
  FUNCIONARIORESPONSAVEL?: FuncionarioBasico;
  FAT?: Fat;
  CODSOLICITACAOCOMPRA?: number;
  SITUACAODOCUMENTACAO: EnumSituacaoDocumentacao;
  CODANDAMENTODOCUMENTACAO?: number | null;
  SITUACAOINTERACAO?: EnumSituacaoInteracao;
  CODANDAMENTOINTERACAO?: number | null;
  QTDINTERACOESABERTAS?: number;
  ANDAMENTOS?: Andamento[];
  ULTIMOMOVIMENTO?: MovimentoAndamento;
  ULTIMOANDAMENTO?: Andamento;
  SOLICITACOESANEXADORAS?: { CODSOLICITACAO: number; NUMERO: string }[];
}

export interface BodyCreateSolicitacao {
  CATEGORIASOLICITACAO: {
    CODCATEGORIASOLICITACAO: number;
    PRAZO: number;
    TIPOSOLICITACAO: {
      CODTIPO: number;
    };
  };
  ORIGEM: {
    CODCIDADE: number;
    CODUNIDADE: number;
  };
  SOLICITANTE: {
    CODSOLICITANTE: number;
  };
  CODFUNCDESTINO?: number; // Override administrativo: destinatário definido manualmente pelo Adm
}

export interface BodySendSolicitacao {
  CODSOLICITACAO: number;
  CODUNIDADEDESTINO: number;
  CODASSUNTO?: number;
  DESPACHO: string;
  ARQUIVOS: Arquivo[];
  FAT?: {
    COD?: number | null;
    TIPOSOLICITANTE: number | string | null;
    TIPOVINCULO: number | string;
    SITUACAO: number | string;
    CREDENCIAMENTO?: Record<string, unknown>;
  };
  AGENDA?: any;
  PROFISSIONALAPOIO?: any;
  SOLICITACAOARMAFOGO?: SolicitacaoArmaFogo;
  EQUIPAMENTOS?: number[];
  CODPROCESSO?: number;
}

export enum EnumSituacaoSolicitacao {
  CONSTRUINDO = 1,
  EM_ANDAMENTO = 2,
  FINALIZADA = 3,
  CANCELADA = 4,
  ANEXADA = 5,
  CONCLUIDA = 6,
}

export const LISTA_SITUACAO_SOLICITACAO = [
  { CODSITUACAO: EnumSituacaoSolicitacao.CONSTRUINDO, TITULO: 'Construindo' },
  { CODSITUACAO: EnumSituacaoSolicitacao.EM_ANDAMENTO, TITULO: 'Em Andamento' },
  { CODSITUACAO: EnumSituacaoSolicitacao.FINALIZADA, TITULO: 'Finalizada' },
  { CODSITUACAO: EnumSituacaoSolicitacao.CONCLUIDA, TITULO: 'Concluída' },
  { CODSITUACAO: EnumSituacaoSolicitacao.CANCELADA, TITULO: 'Cancelada' },
  { CODSITUACAO: EnumSituacaoSolicitacao.ANEXADA, TITULO: 'Anexada' },
];

export enum EnumTipoListaSolicitacao {
  A_RECEBER = 1, // Solicitações na Unidade do usuário logado pendentes de recebimento
  NA_UNIDADE = 2, // Solicitações correntes na Unidade do usuário logado
  FORA_DA_UNIDADE = 3, // Solicitações correntes em outras unidades, mas de origem ou responsabilidade da Unidade do usuário logado
}
